import { ModalMediaCardStructure } from 'common/components';
import { CEILINGS_CDN_PATH } from '../../ceilings-constants';
import { MoreInfoCardStructure } from '../ceilings-more-info';

export const MOUNTING_TYPE_LIST: ModalMediaCardStructure<MoreInfoCardStructure>[] = [
  {
    imgSrc: `${CEILINGS_CDN_PATH}/mounting-type/1.jpg/1.jpg`,
    modalImgSrc: `${CEILINGS_CDN_PATH}/mounting-type-popup/1.jpg/1.jpg`,
    title: 'mounting-type-section.gapless.title',
    description: 'mounting-type-section.gapless.description',
  },
  {
    imgSrc: `${CEILINGS_CDN_PATH}/mounting-type/2.jpg/2.jpg`,
    modalImgSrc: `${CEILINGS_CDN_PATH}/mounting-type-popup/2.jpg/2.jpg`,
    title: 'mounting-type-section.shadow.title',
    description: 'mounting-type-section.shadow.description',
  },
  {
    imgSrc: `${CEILINGS_CDN_PATH}/mounting-type/3.jpg/3.jpg`,
    modalImgSrc: `${CEILINGS_CDN_PATH}/mounting-type-popup/3.jpg/3.jpg`,
    title: 'mounting-type-section.two-level.title',
    description: 'mounting-type-section.two-level.description',
  },
];
